var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"extended-panel activity-panel poi-manager-panel routed-extended-page"},[_c('poi-manager-panel',{staticClass:"side-panel-fill",on:{"toggleUtilityPanel":_vm.goBack}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }